import React, { Component } from 'react';
import { Divider, Popconfirm, Table } from 'antd';
import { queryFilePreview } from '@api/pub/attachment';

class TableFiles extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  columns = () => {
    return [
      {
        title: '文件名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '附件',
        dataIndex: 'files',
        key: 'files',
        render: (text, record) => {
          return text
            ? text.map(item => {
                return (
                  <a
                    style={{ display: 'block' }}
                    onClick={() => queryFilePreview(item)}
                    key={item.uuid}
                  >
                    {item.name}
                  </a>
                );
              })
            : '';
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => {
          return (
            <div>
              <a onClick={() => this.props.editProjFile(record)}>编辑</a>
              <Divider type="vertical" />
              <Popconfirm
                placement="leftTop"
                title="确定删除文件？"
                onConfirm={() => this.props.delProjFile(record.uuid)}
                okText="确定"
                cancelText="取消"
              >
                <a>删除</a>
              </Popconfirm>
            </div>
          );
        },
      },
    ];
  };

  render() {
    const { data, pagination, isLoading } = this.props;
    return (
      <Table
        columns={this.columns()}
        dataSource={data}
        pagination={pagination}
        rowKey="uuid"
        loading={isLoading}
        onChange={this.props.onChange}
      />
    );
  }
}

export default TableFiles;



// WEBPACK FOOTER //
// ./src/components/task/project/pageDetailManage/TableFiles.js